import React from 'react';
import { FileText, FileType, Headphones, Camera, Image, Rows, GitBranch, Notebook, Youtube, Calendar, Mail, Globe, Wand, ScrollText, Code2 } from 'lucide-react';
import { IconKey } from './types';
const ICONS: Record<IconKey, React.FC<{
  size?: number;
  className?: string;
  strokeWidth?: number;
}>> = {
  FileText,
  FileType,
  Headphones,
  Camera,
  Image,
  Rows,
  GitBranch,
  Notebook,
  Youtube,
  Calendar,
  Mail,
  Globe,
  Wand,
  ScrollText,
  Code2
};
export function SkillIcon({
  icon,
  size = 18,
  className,
  strokeWidth = 1.5
}: {
  icon: IconKey;
  size?: number;
  className?: string;
  strokeWidth?: number;
}) {
  const Component = ICONS[icon] ?? FileText;
  return <Component size={size} className={className} strokeWidth={strokeWidth} data-id="element-1718" />;
}